import { Navigate } from "react-router-dom";

function BusinessProtectedRoute({ children }) {

  const token = localStorage.getItem("token");
  const mode = localStorage.getItem("mode");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (mode !== "business") {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default BusinessProtectedRoute;